import React from "react";
import {
  isCapacitorApp,
  openExternalUrl,
} from "../../utils/subscriptionHandler";

// Where the public legal pages are hosted. We always link to the canonical
// domain so the Capacitor app can open them in the system browser without
// hitting a missing-route inside the WebView.
const PUBLIC_HOST = "https://lyrical-toolkit.com";

const LegalLink = ({ href, children }) => {
  const handleClick = (e) => {
    if (isCapacitorApp()) {
      e.preventDefault();
      openExternalUrl(`${PUBLIC_HOST}${href}`);
    }
    // On web, fall through to default anchor navigation
  };
  return (
    <a
      href={href}
      onClick={handleClick}
      className="hover:text-gold-400"
      style={{ color: "#ffffff" }}
    >
      {children}
    </a>
  );
};

const Footer = ({ isMobile }) => {
  return (
    <footer
      className="border-t border-forest-800 bg-forest-900 text-forest-300 text-[6px] sm:text-sm"
      style={{
        marginTop: "auto",
        paddingBottom: isMobile
          ? "calc(5rem + env(safe-area-inset-bottom, 0px))"
          : undefined,
      }}
    >
      <div className="max-w-6xl mx-auto px-1 sm:px-4 py-3 sm:py-4 flex flex-wrap items-center justify-center gap-x-0.5 gap-y-1 sm:gap-x-3 sm:gap-y-2 text-center">
        <span className="text-forest-400">© Lyrical Toolkit</span>
        <span className="text-forest-700" aria-hidden="true">·</span>
        <LegalLink href="/privacy">Privacy</LegalLink>
        <span className="text-forest-700" aria-hidden="true">·</span>
        <LegalLink href="/terms">Terms</LegalLink>
        <span className="text-forest-700" aria-hidden="true">·</span>
        <LegalLink href="/subscription-terms">Subscription</LegalLink>
        <span className="text-forest-700" aria-hidden="true">·</span>
        <LegalLink href="/dmca">DMCA</LegalLink>
      </div>
    </footer>
  );
};

export default Footer;
